import React from "react";
//Material imports
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles"; //Limitless imports

import { withi18n } from "../../hocs/i18n";
var useStyles = makeStyles({
  buttonFooterContainer: {
    display: "flex",
    flex: "1",
    justifyContent: "center",
    alignItems: "center",
    borderTop: "2px solid rgba(0, 0, 0, 0.06)"
  },
  buttonWrapper: {
    height: 44,
    textAlign: "center"
  }
});

var ButtonFooter = function ButtonFooter(_ref) {
  var onClick = _ref.onClick,
      title = _ref.title,
      t = _ref.t,
      id = _ref.id;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.buttonFooterContainer
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.buttonWrapper,
    color: "primary",
    onClick: onClick,
    component: "div",
    id: id
  }, t(title)));
};

export default withi18n(ButtonFooter);